/**
 * Resultsgate API
 * Open API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SampleCriteria { 
    categoryId?: number;
    customerId?: number;
    dateFrom?: string;
    dateTo?: string;
    furColor?: string;
    labCode?: string;
    name?: string;
    protocolNo?: string;
}

